"use client";

import type { WDescriptiveWindowContent } from "@/lib/api/cms-window-content";
import { ParagraphRenderer } from "@/components/cms/Paragraphs/ParagraphRenderer";

/**
 * WDedicatedDescriptiveWindow - okno opisowe.
 *
 * Dziala jak `c_descriptive_page` (strona opisowa), tylko jako OKNO (w_*)
 * umieszczane w strefach CMS (np. `main` na stronie glownej). Tresc to akapity
 * systemu `imp_paragraph` renderowane wspoldzielonym `<ParagraphRenderer>` -
 * te same 22 layouty co strona opisowa.
 *
 * **Data source:** `W_DEDICATED_DESCRIPTIVE_WINDOW_CONTROLLER::getApiContent()` ->
 * `paragraphs` (z `IPARAGRAPH_CONTROLLER::getForApi()`).
 */
export function WDedicatedDescriptiveWindow({ content }: WDedicatedDescriptiveWindowProps) {
  if (!content || !Array.isArray(content.paragraphs) || content.paragraphs.length === 0) {
    return null;
  }

  return <ParagraphRenderer paragraphs={content.paragraphs} />;
}

export type WDedicatedDescriptiveWindowProps = {
  content: WDescriptiveWindowContent;
};

export default WDedicatedDescriptiveWindow;
